import React from 'react';

import { Container, Background, ContainerLogo, RainbowLine } from './styles';

const Navbar = (): JSX.Element => {
  return (
    <Container>
      <Background>
        <ContainerLogo />
      </Background>
      <RainbowLine />
    </Container>
  );
};

export default Navbar;
